import React from 'react'
import { BillboardText, List, ListItem, Paragraph, colors } from '@fs/zion-ui'
import { NoticeWarning } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { NoticeProtected } from '@fs/zion-icon/dist/cjs/icons'
import { sessionizeUrl } from '../../helpers/url_helper'
import { isOrdinanceSharingOnly } from '../../helpers/family_helper'

const getIcon = (group) => {
  return <ListItem.Avatar src={sessionizeUrl(group?.imageUrl)} monogram={group?.name?.charAt(0)} />
}

const FamilyGroupsList = ({ familyGroups }) => {
  const { t } = useTranslation()

  const individualFamilyGroups = familyGroups?.filter((group) => group?.familyGroupId !== 'ALL')

  const getEndElement = ({ group }) => {
    if (group?.memberStatus === 'PENDING') {
      return (
        <ListItem.MetaText
          text={<span style={{ color: colors.yellow30 }}>{t('groups.pending-approval', 'Pending approval...*')}</span>}
        />
      )
    }

    if (group?.memberStatus === 'ADMIN') {
      return (
        <ListItem.MetaText
          text={
            <span>
              {t('groups.admin', 'Admin')}
              <NoticeProtected size="sm" />
            </span>
          }
        />
      )
    }

    return null
  }

  return (
    <List data-testid="family-groups-list">
      {individualFamilyGroups &&
        individualFamilyGroups.map((group, ind) => {
          return (
            <ListItem
              disabled={group?.memberStatus === 'PENDING'}
              key={group?.id}
              data-testid={`group-list-item-${ind}`}
              startElement={getIcon(group)}
              primaryText={group?.name}
              secondaryText={
                <div>
                  {group?.description}
                  {isOrdinanceSharingOnly(group?.types) && (
                    <BillboardText primaryColor={colors.yellow30}>
                      <Paragraph size="xs">
                        <NoticeWarning size="xs" />{' '}
                        {t('familygroups.ordinance-sharing-only', 'Ordinance Sharing Only*')}
                      </Paragraph>
                    </BillboardText>
                  )}
                </div>
              }
              endElement={getEndElement({ group })}
              linkName="Group:GROUP_ITEM:CLICK"
              to={`/groups/${group?.id}`}
            />
          )
        })}
    </List>
  )
}

export default FamilyGroupsList
